import { InitXSRFProtection } from '@rhybus/api'
import { USER_SESSION_ID } from '../config/session-constants'
 
 
const formatHost = (host: string) => {
  // eslint-disable-next-line no-restricted-globals
  if(location.host.indexOf('www.') === 0){
    // eslint-disable-next-line no-restricted-globals
    return location.host.replace('www.','')
  }
 
  return host
}
 
export const sitePath = `${window.location.origin}`
export const siteHost = `${formatHost(window.location.host)}`
 
//export const apiPath = sitePath + '/api'
export const apiPath =process.env.REACT_APP_RHYBUS_API_URL + '/api'
 
 
 
// eslint-disable-next-line no-useless-concat
//export const apiPath = 'https://localhost:3001' + '/api'
 
// Fetch interceptor with SESSION_ID header and 401 handling
const originalFetch = window.fetch.bind(window)
const fetchWith401Intercept: typeof window.fetch = async (...args) => {
  try {
    const [resource, init] = args
    // Get session ID from localStorage
    const sessionId = localStorage.getItem(USER_SESSION_ID)
    // Prepare headers with session ID
    const headers = new Headers(init?.headers)
    // Add SESSION_ID header if available
    if (sessionId) {
      headers.set(USER_SESSION_ID, sessionId)
    }
    // Create new request with updated headers
    const modifiedInit: RequestInit = {
      ...init,
      headers,
    }
    // Execute fetch with modified headers
    const response = await originalFetch(resource, modifiedInit)
    // Handle 401 Unauthorized responses (role change detected)
    if (response.status === 401 && response.statusText === 'Unauthorized') {
      try {
        window.dispatchEvent(new CustomEvent('rhybus-auth-required'))
      } catch (eventError) {
        console.error('Error dispatching auth event:', eventError)
      }
    }
 
    return response
  } catch (error) {
    console.error('Error in fetch interceptor:', error)
    // Re-throw to allow normal error handling
    throw error
  }
}
 
export const fetchProvider = {
  Headers,
  Request,
  Response,
  fetch: fetchWith401Intercept,
}
 
/**
 * 
 * @returns true if call to InitXSRFProtection was successful
 *          false if an error occurred
 */
export async function xsrfInitEffect() {
  try {
    await InitXSRFProtection(fetchProvider, apiPath)
    return true
  } catch (error:any) {
    console.error('Failed to initialize XSRF protection', error)
    console.error('Local DEV? Visit /localdev and then retry to resolve.')
    
    if (error.name === 'TypeError') {
      window.location.href = '/esglocaldev'
    }
    return false
  }
}
 
 